module.exports = __webpack_public_path__ + "static/media/plus.5b5c93dd.svg";